// Third Party Imports
import React from 'react';

// HA Artifactory Imports
import FormSelect from '@homeaway/react-form-select';

// Relative Imports
import ContinueButtonHolder from '../ButtonHolder/ContinueButtonHolder';
import AlertBox from '../Alert/Alert';
import './BrandDetermination.less';
import getCurrencySymbol from '../utils/currencyUtil';
import InfoCard from '../Card/InfoCard';

class BrandDetermination extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.triggerEdapPageViewAction();
    }


    getCurrencyListItems = (currencyList) => {
        const {translations} = this.props;
        const items = currencyList && currencyList.length > 0 ?
            currencyList.map((e) => ({
                label: `${getCurrencySymbol(e)} (${translations[`ipmob.currency.${e}`] ? translations[`ipmob.currency.${e}`] : e})`,
                value: e
            })) :
            [];
        items.unshift('');
        return items;
    }

    getBankingCountryListItems = (bankingCountryList) => {
        const {translations} = this.props;
        const items = bankingCountryList && bankingCountryList.length > 0 ?
            bankingCountryList.map((e) => ({
                label: translations[`ipmob.brand_determination.country.${e.countryCode}`],
                value: e.countryCode
            })) : [];
        items.unshift('');
        return items;
    }

    renderCurrencyComponent = (currencyList) => {
        const {currency, translations, handleCurrencyChange, handleCurrencyOnBlur, currencyError} = this.props;
        const currencyHead = currencyList.length === 1? translations['ipmob.brand_determination.sub_heading_3']: translations['ipmob.brand_determination.sub_heading_2'];
        return (<div>
                    <div className="wrapper">
                        <div className="content-col-text sub-head">
                            <h3>{currencyHead}</h3>
                        </div>
                    </div>
                    <div className="wrapper">
                        <div className="content-col-text">
                            <div className="desc">{translations['ipmob.brand_determination.sub_heading_2.desc']}</div>
                        </div>
                    </div>
                    <div className="wrapper">
                        <div className="content-col">
                            {currencyList.length === 1
                                ? <div className="currency-desc">
                                    {`${getCurrencySymbol(currencyList[0])} (${translations[`ipmob.currency.${currencyList[0]}`] ? translations[`ipmob.currency.${currencyList[0]}`] : currencyList[0]})`}
                                </div>
                                : <FormSelect
                                        id="currencySelection"
                                        name="Currency selected"
                                        items={this.getCurrencyListItems(currencyList)}
                                        label={translations['ipmob.currency']}
                                        value={currency}
                                        onChange={handleCurrencyChange}
                                        errorMsg={translations[currencyError]}
                                        onBlur={handleCurrencyOnBlur}
                                  />
                            }
                        </div>
                    </div>
               </div>)
    }




    render() {
        const {
            translations,

            bankingCountryList,
            bankingCountryCode,
            bankingCountryCodeError,
            handleBankingCountryChange,
            handleBankingCountryOnBlur,


            currencyList,

            serviceError,
            handleAlertDismiss,
            enableContinueButton,
            enableBackButton,
            handleFormSubmit,
            handleBackButtonClick,
        } = this.props;

        return (
            <div id="brandDetermination" className="brand-determination">
                <div className="brand-determination-container">
                        <div className="form-col">
                            {(serviceError) ? (
                                <div className="alert-panel">
                                    <AlertBox
                                        messageKey={serviceError}
                                        translations={translations}
                                        handleAlertDismiss={handleAlertDismiss}
                                        size={'sm'}
                                    />
                                </div>
                            ) : null}

                            <div className="wrapper">
                                <div className="content-col-text panel-head">
                                    <h1 className="head">{translations['ipmob.brand_determination.heading_1']}</h1>
                                </div>
                            </div>
                            <div className="wrapper">
                                <div className="content-col-text head">
                                    <div className="desc">{translations['ipmob.brand_determination.heading_1.desc']}</div>
                                </div>
                            </div>
                            <form role="form" onSubmit={handleFormSubmit}>
                                <div className="input-container" aria-label="Big form">
                                    <div className="wrapper">
                                        <div className="content-col-text sub-head">
                                            <h3>{translations['ipmob.brand_determination.sub_heading_1']}</h3>
                                        </div>
                                    </div>
                                    <div className="wrapper">
                                        <div className="content-col-text">
                                            <div className="desc">{translations['ipmob.brand_determination.sub_heading_1.desc']}</div>
                                        </div>
                                    </div>
                                    <div className="wrapper">
                                        <div className="content-col">
                                            <FormSelect
                                                id="bankingCountry"
                                                name="Banking Country selected"
                                                items={this.getBankingCountryListItems(bankingCountryList)}
                                                label={translations['ipmob.mailing_address.label_1']}
                                                value={bankingCountryCode}
                                                onChange={handleBankingCountryChange}
                                                errorMsg={translations[bankingCountryCodeError]}
                                                onBlur={handleBankingCountryOnBlur}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {currencyList && currencyList.length > 0
                                    ? this.renderCurrencyComponent(currencyList)
                                    : null
                                }
                                <ContinueButtonHolder
                                    enableContinueButton={enableContinueButton}
                                    handleContinueButtonClick={handleFormSubmit}
                                    translations={translations}
                                    enableBackButton={enableBackButton}
                                    handleBackButtonClick={handleBackButtonClick}
                                    continueButtonId={'brandDeterminationContinueBtn'}
                                />
                            </form>
                        </div>

                        <div className="content-col info-card-col">
                            <InfoCard className="banking-loc-info-card">
                                <h2 className="info-card-header">{translations['ipmob.brand_determination.info.heading_1']}</h2>
                                <p className="info-card-text">{translations['ipmob.brand_determination.info.heading_1.desc']}</p>
                            </InfoCard>
                        </div>
                </div>
            </div>
        );
    }
}

export default BrandDetermination;
